import React, { useState, useEffect } from "react";

const FastSpringModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    window.addEventListener("fastspring:open", handleOpen);
    window.addEventListener("fastspring:close", handleClose);

    return () => {
      window.removeEventListener("fastspring:open", handleOpen);
      window.removeEventListener("fastspring:close", handleClose);
    };
  }, []);

  return (
    <div
      className={`fastspring-modal ${isOpen ? "visible" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-label="Shopping Cart"
    >
      {/* Modal content will be injected by FastSpring */}
    </div>
  );
};

export default FastSpringModal;
